import { createAction } from 'typesafe-actions';
import { addExperienceCategory } from './components/CreateModal/CreateModal.utils';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { AsyncRequestStatus } from '@ane/core/lib/models';
import { DRAFT_REDUCER_KEYS, REDUCER_KEYS, ROOT_REDUCER_KEYS, METRICS_REDUCER_KEYS } from '../Vivace.epics';
import VivaceResoures from '../VivaceResoures';
import { getMetadataFromMetricDetailsWithFilePath, getPrimaryDataSourceFromMdl, isQuickCompilationSuccessful, transformQuickCompileResult, } from './components/Wizard/MetricWizard.utils';
import { combineEpics } from 'redux-observable';
import { getWorkspaceIdSelector } from '../Maui.selectors';
import { addOrUpdateInstancesInMDLComputationFile, addOrUpdateMetricsInMDLComputationFile, renameStatistic, } from '../../common/utils/MDLComputations.utils';
import NavigationService from '@ane/core/lib/services/NavigationService';
import { MetricsAuthoringRouteUtils } from '@ane/exp-data/lib/routes/MetricsAuthoringRoute.utils';
import { MAUIDraftEntityPaths } from '../../common/models/MAUI.models';
import { MetricsAuthoringScenarioLoggingNames } from '@ane/exp-data/lib/telemetry/MetricsAuthoringScenarioLoggingNames';
var METRIC_WIZARD_REDUCER_KEYS;
(function (METRIC_WIZARD_REDUCER_KEYS) {
    METRIC_WIZARD_REDUCER_KEYS["metadata"] = "metadata";
    METRIC_WIZARD_REDUCER_KEYS["metric_details"] = "metric_details";
})(METRIC_WIZARD_REDUCER_KEYS || (METRIC_WIZARD_REDUCER_KEYS = {}));
const ACTION_PREFIX = 'METRICS_AUTHORING/DRAFT';
export const ACTION_TYPES = {
    METRIC_METADATA_SET: `${ACTION_PREFIX}/METRIC_METADATA_SET`,
    METRIC_METADATA_RESET: `${ACTION_PREFIX}/METRIC_METADATA_RESET`,
    METRIC_DETAILS_GET: `${ACTION_PREFIX}/METRIC_DETAILS_GET`,
    METRIC_DETAILS_RESET: `${ACTION_PREFIX}/METRIC_DETAILS_RESET`,
    METRIC_QUICK_VALIDATE_RESET: `${ACTION_PREFIX}/METRIC_QUICK_VALIDATE_RESET`,
    METRIC_CREATE_GET: `${ACTION_PREFIX}/METRIC_CREATE_GET`,
    METRIC_CREATE_PUT: `${ACTION_PREFIX}/METRIC_CREATE_PUT`,
    METRIC_UPDATE_PUT: `${ACTION_PREFIX}/METRIC_UPDATE_PUT`,
    METRIC_RESET_CREATE: `${ACTION_PREFIX}/METRIC_RESET_CREATE`,
    METRIC_QUICK_COMPILE_PUT: `${ACTION_PREFIX}/METRIC_QUICK_COMPILE_PUT`,
    METRIC_QUICK_COMPUTE_PUT: `${ACTION_PREFIX}/METRIC_QUICK_COMPUTE_PUT`,
    METRIC_QUICK_VALIDATE_GET: `${ACTION_PREFIX}/METRIC_QUICK_VALIDATE_GET`,
    METRIC_QUICK_VALIDATE_CANCEL: `${ACTION_PREFIX}/METRIC_QUICK_VALIDATE_CANCEL`,
    METRIC_QUICK_VALIDATE_CHECK: `${ACTION_PREFIX}/METRIC_QUICK_VALIDATE_CHECK`,
    METRIC_DATASOURCE_GET: `${ACTION_PREFIX}/METRIC_DATASOURCE_GET`,
    METRIC_DATASOURCE_DETAILS_GET: `${ACTION_PREFIX}/METRIC_DATASOURCE_DETAILS_GET`,
    CUSTOM_DIM_SET_ALL: `${ACTION_PREFIX}/CUSTOM_DIM_SET_ALL`,
    CUSTOM_DIM_SET: `${ACTION_PREFIX}/CUSTOM_DIM_SET`,
    CUSTOM_DIM_SET_USE: `${ACTION_PREFIX}/CUSTOM_DIM_SET_USE`,
    TEMPLATE_METRIC_CREATE_GET: `${ACTION_PREFIX}/TEMPLATE_METRIC_CREATE_GET`,
    COMPUTATION_TEMPLATE_INSTANCES_UPDATED: `${ACTION_PREFIX}/COMPUTATION_TEMPLATE_INSTANCES_UPDATED`,
    COMPUTATION_TEMPLATE_INSTANCE_METRICS_NEW: `${ACTION_PREFIX}/COMPUTATION_TEMPLATE_INSTANCE_METRICS_NEW`,
    SCORECARD_LAYOUT_PATHS_GET: `${ACTION_PREFIX}/SCORECARD_LAYOUT_PATHS_GET`,
    SCORECARD_LAYOUT_FILE_GET: `${ACTION_PREFIX}/SCORECARD_LAYOUT_FILE_GET`,
    SCORECARD_LAYOUT_FILE_PUT: `${ACTION_PREFIX}/SCORECARD_LAYOUT_FILE_PUT`,
};
export const setMetricMetadata = createAction(ACTION_TYPES.METRIC_METADATA_SET, (action) => (metadata) => action(addExperienceCategory(metadata)));
export const resetMetricMetadata = createAction(ACTION_TYPES.METRIC_METADATA_RESET, (action) => () => action());
export const resetMetricDetails = createAction(ACTION_TYPES.METRIC_DETAILS_RESET, (action) => () => action());
const loadMetricDetails = {
    actionPrefix: ACTION_TYPES.METRIC_DETAILS_GET,
    reduxKeyNested: () => [
        ROOT_REDUCER_KEYS.draft,
        DRAFT_REDUCER_KEYS.metrics,
        REDUCER_KEYS.draft.metrics.metric_wizard,
        METRIC_WIZARD_REDUCER_KEYS.metric_details,
    ],
    loadResource: ({ workspaceId, metricSetName, draftName, metricInternalName }, state) => VivaceResoures.getMetric({
        workspaceId,
        metricSetName,
        draftName,
        metricInternalName,
    }),
    onCompleteSuccess: (resourceResult) => {
        return resourceResult.length > 0 ? resourceResult[0] : null;
    },
    afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
        return !!outputPayload ? [setMetricMetadata(getMetadataFromMetricDetailsWithFilePath(outputPayload))] : [];
    },
};
export const resetCreateMetricState = createAction(ACTION_TYPES.METRIC_RESET_CREATE, (action) => () => action());
const putComputationsWithUpdatesEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_CREATE_PUT,
    reduxKeyNested: () => [
        ROOT_REDUCER_KEYS.draft,
        DRAFT_REDUCER_KEYS.metrics,
        REDUCER_KEYS.draft.metrics.metric_wizard,
        REDUCER_KEYS.draft.metrics.create_put,
    ],
    loadResource: ({ metricSetName, draftName, computationFileName, mdlComputations }, state) => VivaceResoures.putMDLComputationFile({
        metricSetName,
        draftName,
        computationFileName,
        workspaceId: getWorkspaceIdSelector(state),
        request: mdlComputations,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload) => {
        const { CompletePendingWork } = inputPayload;
        if (CompletePendingWork) {
            CompletePendingWork(MetricsAuthoringScenarioLoggingNames.Create_ComputationTemplateInstance);
        }
        NavigationService.navigateTo(MetricsAuthoringRouteUtils.routes.viewMetricSet.url({
            metricSetName: inputPayload.metricSetName,
            draftName: inputPayload.draftName,
            entityName: MAUIDraftEntityPaths.metric,
        }));
        const actions = [resetCreateMetricState()];
        return actions;
    },
    afterActionsOnFailure: (inputPayload) => {
        const { CancelPendingWork } = inputPayload;
        if (CancelPendingWork) {
            CancelPendingWork(MetricsAuthoringScenarioLoggingNames.Create_ComputationTemplateInstance);
        }
        return [];
    },
};
export const putComputationsWithUpdatesEpicReducer = loadResourcesUtils(putComputationsWithUpdatesEpicReducerArg);
const putComputationsWithAdditionalUpdatesEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_UPDATE_PUT,
    reduxKeyNested: () => [
        ROOT_REDUCER_KEYS.draft,
        DRAFT_REDUCER_KEYS.metrics,
        REDUCER_KEYS.draft.metrics.metric_wizard,
        REDUCER_KEYS.draft.metrics.create_get,
    ],
    loadResource: ({ metricSetName, draftName, computationFileName, mdlComputations }, state) => {
        return VivaceResoures.putMDLComputationFile({
            metricSetName,
            draftName,
            computationFileName,
            workspaceId: getWorkspaceIdSelector(state),
            request: mdlComputations,
        });
    },
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
        var _a;
        const actions = [
            getNewTemplateInstancesEpicReducer.actionCreators.load(Object.assign(Object.assign({}, inputPayload), { oldInstances: ((_a = state.maui.draft.computation_template_instances) === null || _a === void 0 ? void 0 : _a.data) || [] })),
        ];
        return actions;
    },
};
export const putComputationsWithAdditionalUpdatesEpicReducer = loadResourcesUtils(putComputationsWithAdditionalUpdatesEpicReducerArg);
const getNewTemplateInstancesEpicReducerArg = {
    actionPrefix: ACTION_TYPES.COMPUTATION_TEMPLATE_INSTANCES_UPDATED,
    reduxKeyNested: () => [],
    loadResource: ({ metricSetName, draftName }, state) => {
        var _a;
        const templateName = ((_a = state.maui.draft.metrics.metric_wizard.metadata) === null || _a === void 0 ? void 0 : _a.metricTemplate) || '';
        return VivaceResoures.getComputationTemplateInstances({
            metricSetName,
            draftName,
            templateName,
            workspaceId: getWorkspaceIdSelector(state),
        });
    },
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
        var _a;
        const newComputationTemplateInstances = outputPayload.filter((instance) => !(inputPayload === null || inputPayload === void 0 ? void 0 : inputPayload.oldInstances.some((oldInstance) => oldInstance.i['@InstanceId'] === instance.i['@InstanceId'])));
        if (newComputationTemplateInstances.length === 0) {
            NavigationService.navigateTo(MetricsAuthoringRouteUtils.routes.viewMetricSet.url({
                metricSetName: inputPayload.metricSetName,
                draftName: inputPayload.draftName,
                entityName: MAUIDraftEntityPaths.metric,
            }));
            const actionsForReturn = [resetCreateMetricState()];
            return actionsForReturn;
        }
        const actions = [
            getMetricsInNewTemplateInstanceEpicReducer.actionCreators.load(Object.assign(Object.assign({}, inputPayload), { newComputationTemplateInstance: newComputationTemplateInstances[0], oldMetrics: ((_a = state.maui.draft.computation_template_instance_metrics) === null || _a === void 0 ? void 0 : _a.data) || [] })),
        ];
        return actions;
    },
};
export const getNewTemplateInstancesEpicReducer = loadResourcesUtils(getNewTemplateInstancesEpicReducerArg);
const getMetricsInNewTemplateInstanceEpicReducerArg = {
    actionPrefix: ACTION_TYPES.COMPUTATION_TEMPLATE_INSTANCE_METRICS_NEW,
    reduxKeyNested: () => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.computation_template_instance_metrics],
    loadResource: ({ metricSetName, draftName }, state) => {
        var _a;
        const templateName = ((_a = state.maui.draft.metrics.metric_wizard.metadata) === null || _a === void 0 ? void 0 : _a.metricTemplate) || '';
        return VivaceResoures.getMetricsForTemplateInstance({
            workspaceId: getWorkspaceIdSelector(state),
            metricSetName,
            draftName,
            templateName,
        });
    },
    onCompleteSuccess: (resourceResult, payload) => {
        if (!resourceResult) {
            return [];
        }
        return resourceResult.filter((metric) => metric.i['@InstanceId'] === payload.newComputationTemplateInstance.i['@InstanceId']);
    },
    afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
        const newMetrics = outputPayload;
        const metricsDeleted = inputPayload.oldMetrics.filter((oldMetric) => !newMetrics.some((newMetric) => newMetric.i['@Name'] === oldMetric.i['@Name']));
        const newMetricsToBeAdded = newMetrics.filter((newMetric) => !inputPayload.oldMetrics.some((oldMetric) => newMetric.i['@Name'] === oldMetric.i['@Name']));
        if (metricsDeleted.length <= 0 || newMetricsToBeAdded.length <= 0 || metricsDeleted.length !== newMetricsToBeAdded.length) {
            // Not handling these cases
            NavigationService.navigateTo(MetricsAuthoringRouteUtils.routes.viewMetricSet.url({
                metricSetName: inputPayload.metricSetName,
                draftName: inputPayload.draftName,
                entityName: MAUIDraftEntityPaths.metric,
            }));
            const actionsForReturn = [resetCreateMetricState()];
            return actionsForReturn;
        }
        const actions = [];
        // for each metric load the scorecard layout paths
        metricsDeleted.forEach((metric) => actions.push(getScorecardLayoutPathsEpicReducer.actionCreators.load(Object.assign(Object.assign({}, inputPayload), { metricName: metric.i['@Name'], metrics: metricsDeleted, newMetricsToBeAdded }))));
        return actions;
    },
};
export const getMetricsInNewTemplateInstanceEpicReducer = loadResourcesUtils(getMetricsInNewTemplateInstanceEpicReducerArg);
const getScorecardLayoutPathsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.SCORECARD_LAYOUT_PATHS_GET,
    reduxKeyNested: (inputPayload) => [ROOT_REDUCER_KEYS.draft, REDUCER_KEYS.draft.scorecard_layout_paths, inputPayload.metricName],
    loadResource: ({ metricSetName, draftName, metricName }, state) => {
        return VivaceResoures.getScorecardLayoutFilePaths({
            metricSetName,
            draftName,
            metricName,
            workspaceId: getWorkspaceIdSelector(state),
        });
    },
    onCompleteSuccess: (resourceResult) => {
        if (!resourceResult) {
            return [];
        }
        return resourceResult.map((res) => res.filePath.split(','));
    },
    afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
        const scorecardObj = state.maui.draft.scorecard_layout_paths;
        const statuses = Object.values(scorecardObj).map((metric) => metric.status);
        const pendingScorecards = statuses.filter((status) => status === AsyncRequestStatus.Pending);
        // if there are no pending scorecards, load the scorecard layouts, this step ensures the actions are triggered after all the scorecard paths are loaded
        if (pendingScorecards.length <= 1) {
            const uniqueFiles = [...new Set(Object.values(scorecardObj).flatMap((metric) => { var _a; return ((_a = metric.data) === null || _a === void 0 ? void 0 : _a.flat()) || []; }))];
            const flattenedNewFiles = [...new Set(outputPayload.flat())];
            const isFileUnique = (file) => {
                return !uniqueFiles.some((existingFile) => existingFile === file);
            };
            flattenedNewFiles.forEach((file) => {
                if (isFileUnique(file)) {
                    uniqueFiles.push(file);
                }
            });
            if (uniqueFiles.length === 0) {
                NavigationService.navigateTo(MetricsAuthoringRouteUtils.routes.viewMetricSet.url({
                    metricSetName: inputPayload.metricSetName,
                    draftName: inputPayload.draftName,
                    entityName: MAUIDraftEntityPaths.metric,
                }));
                const actionsForReturn = [resetCreateMetricState()];
                return actionsForReturn;
            }
            const actions = uniqueFiles.map((filePath) => getScorecardLayoutsEpicReducer.actionCreators.load(Object.assign(Object.assign({}, inputPayload), { filePath, metrics: inputPayload.metrics, newMetricsToBeAdded: inputPayload.newMetricsToBeAdded })));
            return actions;
        }
        return [];
    },
};
export const getScorecardLayoutPathsEpicReducer = loadResourcesUtils(getScorecardLayoutPathsEpicReducerArg);
const getScorecardLayoutsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.SCORECARD_LAYOUT_FILE_GET,
    reduxKeyNested: (inputPayload) => [],
    loadResource: ({ metricSetName, draftName, filePath }, state) => {
        return VivaceResoures.getScorecardLayoutFile({
            metricSetName,
            draftName,
            filePath,
            workspaceId: getWorkspaceIdSelector(state),
        });
    },
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
        inputPayload.metrics.forEach((metric) => {
            const newMetric = inputPayload.newMetricsToBeAdded[inputPayload.metrics.indexOf(metric)];
            renameStatistic(outputPayload, metric.i['@Name'], newMetric.i['@Name']);
        });
        const actions = [
            putScorecardLayoutFilesEpicReducer.actionCreators.load(Object.assign(Object.assign({}, inputPayload), { scorecardLayoutFile: outputPayload })),
        ];
        return actions;
    },
};
export const getScorecardLayoutsEpicReducer = loadResourcesUtils(getScorecardLayoutsEpicReducerArg);
const putScorecardLayoutFilesEpicReducerArg = {
    actionPrefix: ACTION_TYPES.SCORECARD_LAYOUT_FILE_PUT,
    reduxKeyNested: (inputPayload) => [],
    loadResource: ({ metricSetName, draftName, filePath, scorecardLayoutFile }, state) => {
        return VivaceResoures.putScorecardLayoutFile({
            metricSetName,
            draftName,
            filePath,
            scorecardLayoutFile,
            workspaceId: getWorkspaceIdSelector(state),
        });
    },
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload) => {
        NavigationService.navigateTo(MetricsAuthoringRouteUtils.routes.viewMetricSet.url({
            metricSetName: inputPayload.metricSetName,
            draftName: inputPayload.draftName,
            entityName: MAUIDraftEntityPaths.metric,
        }));
        const actions = [resetCreateMetricState()];
        return actions;
    },
};
export const putScorecardLayoutFilesEpicReducer = loadResourcesUtils(putScorecardLayoutFilesEpicReducerArg);
const createMetricEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_CREATE_GET,
    reduxKeyNested: () => [
        ROOT_REDUCER_KEYS.draft,
        DRAFT_REDUCER_KEYS.metrics,
        REDUCER_KEYS.draft.metrics.metric_wizard,
        REDUCER_KEYS.draft.metrics.create_get,
    ],
    loadResource: ({ metricSetName, draftName, computationFileName }, state) => VivaceResoures.getMDLComputationFile({
        metricSetName,
        draftName,
        computationFileName,
        workspaceId: getWorkspaceIdSelector(state),
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload, computationsFile) => {
        const newComputationsFile = addOrUpdateMetricsInMDLComputationFile(computationsFile, inputPayload.metric);
        return [putComputationsWithUpdatesEpicReducer.actionCreators.load(Object.assign(Object.assign({}, inputPayload), { mdlComputations: newComputationsFile }))];
    },
};
const createComutationTemplateInstanceEpicReducerArg = {
    actionPrefix: ACTION_TYPES.TEMPLATE_METRIC_CREATE_GET,
    reduxKeyNested: () => [
        ROOT_REDUCER_KEYS.draft,
        DRAFT_REDUCER_KEYS.metrics,
        REDUCER_KEYS.draft.metrics.metric_wizard,
        REDUCER_KEYS.draft.metrics.create_get,
    ],
    loadResource: ({ metricSetName, draftName, computationFileName }, state) => {
        return VivaceResoures.getMDLComputationFile({
            metricSetName,
            draftName,
            computationFileName,
            workspaceId: getWorkspaceIdSelector(state),
        });
    },
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload, computationsFile, state) => {
        var _a, _b;
        const newComputationsFile = addOrUpdateInstancesInMDLComputationFile(computationsFile, inputPayload.ComputationTemplateInstance, inputPayload.OldComputationTemplateInstance);
        // if there are any metrics associated with the template instance
        if (inputPayload.OldComputationTemplateInstance &&
            ((_a = state.maui.draft.computation_template_instance_metrics) === null || _a === void 0 ? void 0 : _a.data) &&
            ((_b = state.maui.draft.computation_template_instance_metrics) === null || _b === void 0 ? void 0 : _b.data.length) > 0) {
            return [
                putComputationsWithAdditionalUpdatesEpicReducer.actionCreators.load(Object.assign(Object.assign({}, inputPayload), { mdlComputations: newComputationsFile })),
            ];
        }
        return [
            putComputationsWithUpdatesEpicReducer.actionCreators.load(Object.assign(Object.assign({}, inputPayload), { mdlComputations: newComputationsFile })),
        ];
    },
};
const quickCompileEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_QUICK_COMPILE_PUT,
    reduxKeyNested: () => [
        ROOT_REDUCER_KEYS.draft,
        DRAFT_REDUCER_KEYS.metrics,
        REDUCER_KEYS.draft.metrics.metric_wizard,
        REDUCER_KEYS.draft.metrics.quick_compile_put,
    ],
    loadResource: (payload, state) => VivaceResoures.quickCompile({
        workspaceId: getWorkspaceIdSelector(state),
        metricSetName: payload.metricSetName,
        draftName: payload.draftName,
        request: payload.request,
        requestId: payload.requestId,
    }),
    onCompleteSuccess: (resourceResult, inputPayload) => {
        var _a;
        const metricColumnObjects = (_a = inputPayload.request.metricObjects) === null || _a === void 0 ? void 0 : _a.concat(inputPayload.request.columnObjects || []);
        return transformQuickCompileResult(metricColumnObjects || [], resourceResult);
    },
    afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
        if (isQuickCompilationSuccessful(outputPayload)) {
            return [
                quickComputeEpicReducer.actionCreators.load({
                    workspaceId: inputPayload.workspaceId,
                    metricSetName: inputPayload.metricSetName,
                    draftName: inputPayload.draftName,
                    request: inputPayload.request,
                    requestId: inputPayload.requestId,
                }),
            ];
        }
        return [];
    },
};
const quickComputeEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_QUICK_COMPUTE_PUT,
    reduxKeyNested: () => [
        ROOT_REDUCER_KEYS.draft,
        DRAFT_REDUCER_KEYS.metrics,
        REDUCER_KEYS.draft.metrics.metric_wizard,
        REDUCER_KEYS.draft.metrics.quick_compute_put,
    ],
    loadResource: (payload, state) => VivaceResoures.quickCompute({
        workspaceId: getWorkspaceIdSelector(state),
        metricSetName: payload.metricSetName,
        draftName: payload.draftName,
        request: payload.request,
        requestId: payload.requestId,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
    afterActionsOnSuccess: (inputPayload) => {
        var _a;
        return [
            loadQuickValidationResultEpicReducer.actionCreators.load({
                workspaceId: inputPayload.workspaceId,
                metricSetName: inputPayload.metricSetName,
                draftName: inputPayload.draftName,
                metricNameList: ((_a = inputPayload.request.metricObjects) === null || _a === void 0 ? void 0 : _a[0].name) || '',
            }),
        ];
    },
};
const loadQuickValidationResultEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_QUICK_VALIDATE_GET,
    reduxKeyNested: () => [
        ROOT_REDUCER_KEYS.draft,
        DRAFT_REDUCER_KEYS.metrics,
        REDUCER_KEYS.draft.metrics.metric_wizard,
        REDUCER_KEYS.draft.metrics.quick_compute_get,
    ],
    loadResource: (payload, state) => VivaceResoures.getQuickValidationResult({
        workspaceId: getWorkspaceIdSelector(state),
        metricSetName: payload.metricSetName,
        draftName: payload.draftName,
        metricNameList: payload.metricNameList,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const resetMetricQuickValidateResult = createAction(ACTION_TYPES.METRIC_QUICK_VALIDATE_RESET, (action) => () => action());
const cancelQuickValidationEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_QUICK_VALIDATE_CANCEL,
    reduxKeyNested: () => [
        ROOT_REDUCER_KEYS.draft,
        DRAFT_REDUCER_KEYS.metrics,
        REDUCER_KEYS.draft.metrics.metric_wizard,
        REDUCER_KEYS.draft.metrics.quick_compute_cancel,
    ],
    loadResource: (payload, state) => VivaceResoures.cancelQuickCompute({
        workspaceId: getWorkspaceIdSelector(state),
        metricSetName: payload.metricSetName,
        draftName: payload.draftName,
        metricNameList: payload.metricNameList,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
const checkQuickValidateEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_QUICK_VALIDATE_CHECK,
    reduxKeyNested: () => [
        ROOT_REDUCER_KEYS.draft,
        DRAFT_REDUCER_KEYS.metrics,
        REDUCER_KEYS.draft.metrics.metric_wizard,
        REDUCER_KEYS.draft.metrics.quick_compute_check,
    ],
    loadResource: (payload, state) => VivaceResoures.checkIfNeedQuickValidation({
        workspaceId: getWorkspaceIdSelector(state),
        metricSetName: payload.metricSetName,
        draftName: payload.draftName,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
const loadDraftDatasourceEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_DATASOURCE_GET,
    reduxKeyNested: () => [
        ROOT_REDUCER_KEYS.draft,
        DRAFT_REDUCER_KEYS.metrics,
        REDUCER_KEYS.draft.metrics.metric_wizard,
        REDUCER_KEYS.draft.metrics.datasource_get,
    ],
    loadResource: (payload, state) => VivaceResoures.getDataSourceForDraft({
        workspaceId: getWorkspaceIdSelector(state),
        metricSetName: payload.metricSetName,
        draftName: payload.draftName,
    }),
    onCompleteSuccess: (resourceResult) => getPrimaryDataSourceFromMdl(resourceResult),
    afterActionsOnSuccess: (inputPayload, outputPayload) => {
        return [
            loadDatasourceDetailsEpicReducer.actionCreators.load({
                workspaceId: inputPayload.workspaceId,
                dataSourceName: outputPayload,
            }),
        ];
    },
};
const loadDatasourceDetailsEpicReducerArg = {
    actionPrefix: ACTION_TYPES.METRIC_DATASOURCE_DETAILS_GET,
    reduxKeyNested: () => [
        ROOT_REDUCER_KEYS.draft,
        DRAFT_REDUCER_KEYS.metrics,
        REDUCER_KEYS.draft.metrics.metric_wizard,
        REDUCER_KEYS.draft.metrics.datasource_details_get,
    ],
    loadResource: (payload, state) => VivaceResoures.getDataSourceDetails({
        workspaceId: getWorkspaceIdSelector(state),
        dataSourceName: payload.dataSourceName,
    }),
    onCompleteSuccess: (resourceResult) => resourceResult,
};
export const createMetricEpicReducer = loadResourcesUtils(createMetricEpicReducerArg);
export const createComutationTemplateInstanceEpicReducer = loadResourcesUtils(createComutationTemplateInstanceEpicReducerArg);
export const loadMetricDetailsEpicReducer = loadResourcesUtils(loadMetricDetails);
export const quickCompileEpicReducer = loadResourcesUtils(quickCompileEpicReducerArg);
export const quickComputeEpicReducer = loadResourcesUtils(quickComputeEpicReducerArg);
export const loadQuickValidationResultEpicReducer = loadResourcesUtils(loadQuickValidationResultEpicReducerArg);
export const cancelQuickValidationEpicReducer = loadResourcesUtils(cancelQuickValidationEpicReducerArg);
export const checkQuickValidateEpicReducer = loadResourcesUtils(checkQuickValidateEpicReducerArg);
export const loadDraftDatasourceEpicReducer = loadResourcesUtils(loadDraftDatasourceEpicReducerArg);
export const loadDatasourceDetailsEpicReducer = loadResourcesUtils(loadDatasourceDetailsEpicReducerArg);
export const metricEpics = combineEpics(loadMetricDetailsEpicReducer.epic, createMetricEpicReducer.epic, putComputationsWithUpdatesEpicReducer.epic, createComutationTemplateInstanceEpicReducer.epic, quickCompileEpicReducer.epic, quickComputeEpicReducer.epic, loadQuickValidationResultEpicReducer.epic, cancelQuickValidationEpicReducer.epic, checkQuickValidateEpicReducer.epic, loadDraftDatasourceEpicReducer.epic, loadDatasourceDetailsEpicReducer.epic, putComputationsWithAdditionalUpdatesEpicReducer.epic, getNewTemplateInstancesEpicReducer.epic, getMetricsInNewTemplateInstanceEpicReducer.epic, getScorecardLayoutPathsEpicReducer.epic, getScorecardLayoutsEpicReducer.epic, putScorecardLayoutFilesEpicReducer.epic);
export const setCustomDimensionAll = createAction(ACTION_TYPES.CUSTOM_DIM_SET_ALL, (action) => (customDimensions) => action(customDimensions));
export const setCustomDimension = createAction(ACTION_TYPES.CUSTOM_DIM_SET, (action) => (customDimension) => action(customDimension));
export const setCustomDimensionUse = createAction(ACTION_TYPES.CUSTOM_DIM_SET_USE, (action) => ({ id, component, inUse }) => action({ id, component, inUse }));

//# sourceMappingURL=Metric.epics.js.map
